import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import { API_URL } from '../config/api'
import './PaymentResult.css'

const MAX_POLLS = 10
const POLL_MS = 2000

export default function PaymentResult() {
  const { token } = useAuth()
  const [status, setStatus] = useState('loading') // loading | paid | pending | cancelled | error
  const [order, setOrder] = useState(null)
  const [polls, setPolls] = useState(0)

  useEffect(() => {
    const paymentId = localStorage.getItem('pendingPaymentId')
    if (!paymentId || !token) { setStatus('error'); return }

    const check = async () => {
      try {
        const res = await fetch(`${API_URL}/api/orders/by-payment/${paymentId}`, {
          headers: { Authorization: `Bearer ${token}` },
        })

        if (res.ok) {
          const data = await res.json()
          const s = data.data?.status
          setOrder(data.data)
          if (s === 'paid') {
            localStorage.removeItem('pendingPaymentId')
            setStatus('paid')
          } else if (s === 'cancelled') {
            setStatus('cancelled')
          } else {
            tryAgain()
          }
          return
        }

        if (res.status === 404) {
          // Webhook hasn't fired yet — poll again
          tryAgain()
          return
        }

        setStatus('error')
      } catch {
        setStatus('error')
      }
    }

    const tryAgain = () => {
      setPolls(p => {
        if (p + 1 >= MAX_POLLS) { setStatus('pending'); return p }
        return p + 1
      })
    }

    check()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [polls, token])

  useEffect(() => {
    if (status === 'loading' && polls > 0) {
      const t = setTimeout(() => setPolls(p => p + 1), POLL_MS)
      return () => clearTimeout(t)
    }
  }, [status, polls])

  if (status === 'loading') return (
    <div className="result-page">
      <div className="result-card">
        <div className="result-spinner" />
        <p>Betaalstatus controleren...</p>
      </div>
    </div>
  )

  if (status === 'paid') return (
    <div className="result-page">
      <div className="result-card result-card--success">
        <div className="result-icon">✅</div>
        <h1>Betaling geslaagd!</h1>
        <p>Bedankt voor je bestelling. We verwerken deze zo snel mogelijk.</p>
        {order?.id && <p className="result-order">Bestelling #{order.id}</p>}
        <div className="result-actions">
          <Link to="/dashboard" className="btn-result-primary">Mijn bestellingen</Link>
          <Link to="/shop" className="btn-result-secondary">Verder winkelen</Link>
        </div>
      </div>
    </div>
  )

  if (status === 'pending') return (
    <div className="result-page">
      <div className="result-card result-card--pending">
        <div className="result-icon">⏳</div>
        <h1>Betaling in behandeling</h1>
        <p>Je betaling wordt nog verwerkt. Je ontvangt een bevestiging per e-mail zodra de betaling is afgerond.</p>
        <div className="result-actions">
          <Link to="/dashboard" className="btn-result-primary">Mijn bestellingen</Link>
        </div>
      </div>
    </div>
  )

  if (status === 'cancelled') return (
    <div className="result-page">
      <div className="result-card result-card--failed">
        <div className="result-icon">❌</div>
        <h1>Betaling mislukt</h1>
        <p>Je betaling is geannuleerd of mislukt. Probeer het opnieuw.</p>
        <div className="result-actions">
          <Link to="/shop" className="btn-result-primary">Terug naar winkel</Link>
        </div>
      </div>
    </div>
  )

  return (
    <div className="result-page">
      <div className="result-card">
        <div className="result-icon">⚠️</div>
        <h1>Er ging iets mis</h1>
        <p>We konden de betaalstatus niet ophalen. Controleer je bestellingen of neem contact op.</p>
        <div className="result-actions">
          <Link to="/dashboard" className="btn-result-primary">Mijn bestellingen</Link>
        </div>
      </div>
    </div>
  )
}
